import { CustomGridColumns } from '../../CustomDataGrid';
import { strPadZeroL } from '~/utils/functions';

export const CbenefColunm: CustomGridColumns[] = [
  {
    field: 'cod_beneficio_fiscal',
    headerName: 'Cód. Benefício Fiscal',
    sortable: false,
    disableColumnMenu: false,
    width: 150,
    renderCell: (row: any) => strPadZeroL(8, row.cod_beneficio_fiscal),
  },
];
